import { call, put, takeLatest } from 'redux-saga/effects';
import { thongKeApi } from '../../../api/thongKeApi';
import { IThongKeSiSoSelectRequest } from '../../../models/request/thong-ke/IThongKeSiSoSelectRequest';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { eThongKeCRMActionTypeIds } from '../../action-types/thong-ke/IThongKeCRMActions';
import { IThongKeCSKHActionTypes } from '../../action-types/thong-ke/IThongKeCSKHActions';
import { actions } from '../../actions/actionsWrapper';
const mainAction = actions.thongKe.crm;

export function* thongKeCRMSaga(): any {
    yield takeLatest(eThongKeCRMActionTypeIds.LOAD_BY_CHIEN_DICH_START, loadByChienDichWorker)
    yield takeLatest(eThongKeCRMActionTypeIds.LOAD_BY_NGUON_BIET_TOI_START, loadByNguonBietToiWorker)

}
function* loadByChienDichWorker(action: IThongKeCSKHActionTypes): any {
    const res: IBaseResponeModel = yield call(thongKeApi.ThongKeCRMByChienDich, action.payload as IThongKeSiSoSelectRequest)
    if (res.is_success) {
        yield put(mainAction.LOAD_BY_CHIEN_DICH_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_BY_CHIEN_DICH_ERROR(res.message ?? "Error"))
    }
}


function* loadByNguonBietToiWorker(action: IThongKeCSKHActionTypes): any {
    const res: IBaseResponeModel = yield call(thongKeApi.ThongKeCRMByNguonBietToi, action.payload as IThongKeSiSoSelectRequest)
    if (res.is_success) {
        yield put(mainAction.LOAD_BY_NGUON_BIET_TOI_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_BY_NGUON_BIET_TOI_ERROR(res.message ?? "Error"))
    }
}
